export const LOGIN_POLICY_CREATE_ACTIVE_SESSIONS_WARNING_STORAGE_KEY =
  "loginPolicyCreateActiveSessionsWarning";
